export default __webpack_public_path__ + "static/media/dreamfest (4).b46e576d.jpg";